// extracted by mini-css-extract-plugin
export default {"toggleContainer":"WeekdayToggle_toggleContainer__mXkGp","active":"WeekdayToggle_active__+GLsm"};